import script from "./FirstLoadOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstLoadOverlay.vue?vue&type=script&setup=true&lang=js"

import "./FirstLoadOverlay.vue?vue&type=style&index=0&id=14035415&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14035415"]])

export default __exports__